import { z } from 'zod';

import { VehicleType } from '@/pages/Fleet/Vehicles/models';
import { ServiceType, Business } from '.';

export interface FeeServiceApi {
  id: string;
  name: string;
  vehicleType: VehicleType;
  serviceType: ServiceType;
  commercialBusiness?: Business;
  fee: string;
  min: number;
  validFrom: string;
  validTo: string;
}

export interface FeeService {
  id: string;
  name: string;
  vehicleType: VehicleType;
  serviceType: ServiceType;
  commercialBusiness?: Business;
  fee: number;
  min: number;
  validFrom: string;
  validTo: string;
}

export interface NewFeeService {
  businessId: string,
  vehicleTypeId: string;
  serviceTypeId: string;
  fee: number;
  min: number;
  validFrom: Date;
  validTo: Date;
}

export const feeServiceSchema = z.object({
  vehicleTypeId: z.string().nonempty('El tipo de vehículo es obligatorio'),
  serviceTypeId: z.string().nonempty('El tipo de servicio es obligatorio'),
  fee: z.string()
    .transform((val) => {
      const numberVal = Number(val);
      if (isNaN(numberVal)) throw new Error('La tarifa debe ser un número válido');
      return numberVal;
    }),
  min: z.string()
    .transform((val) => {
      const numberVal = Number(val);
      if (isNaN(numberVal)) throw new Error('El mínimo debe ser un número válido');
      return numberVal;
    }),
  validFrom: z.date(),
  validTo: z.date(),
});

export type FeeServiceSchema = z.infer<typeof feeServiceSchema>;

export type FeeServiceFormInput = z.input<typeof feeServiceSchema>;
